export enum CenterType {
  WholeLife = 'WHOLE_LIFE',
  Pediatric = 'PEDIATRIC',
  Adult = 'ADULT',
}
